enum TYPES {
    SYSTEM = 1,
    CLIENT = 2
}

export { TYPES };